import styled from 'styled-components';

export const AddButton = styled.button`
    font-family: 'Space Grotesk', sans-serif;
    font-size: 12px;
    line-height: 16px;

    background: transparent;
    border: 0;
    cursor: pointer;
    color: #6da4d3;
    border-radius: 2px;

    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px;

    transition: background 0.3s ease-in-out;

    &:hover {
        background: #EAF6FF;
    }
`;

export const CloseButton = styled.button`
    border: 0;
    box-sizing: border-box;
    height: 30px;
    padding: 0;
    width: 30px;

    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;

    &:hover {
        background-color: buttonface;
    }
`;

export const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 32px;
    padding: 24px;
    width: 656px;
    flex: 1;
`;

export const Legend = styled.legend`
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #262d3c;
`;

export const Title = styled.h4`
    font-family: 'Space Grotesk', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 26px;
    line-height: 24px;
    margin: 0;
    color: #262d3c;
`;
